import { render, staticRenderFns } from "./Resum.vue?vue&type=template&id=6fdfcda2&"
import script from "./Resum.vue?vue&type=script&lang=js&"
export * from "./Resum.vue?vue&type=script&lang=js&"
import style0 from "./Resum.vue?vue&type=style&index=0&id=6fdfcda2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports